import axios from 'axios';
import auth from './auth';

let API_URL = 'https://api.escapeitkit.com:443/api/';
if (location.hostname === 'localhost') {
    API_URL = 'http://localhost:9000/api/';
}

export default {
    checkCouponCode: function(coupon, kit_id) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'coupons', {coupon: coupon}, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/coupons.js